import React from 'react';
import { Signal, Wifi, BatteryFull } from 'lucide-react';

/**
 * Status bar superior del device frame.
 */
const StatusBar = ({ time = '09:24' }) => (
  <div className="phone-status" aria-hidden>
    <span>{time}</span>
    <span className="flex items-center gap-1.5">
      <Signal className="w-4 h-4" />
      <Wifi className="w-4 h-4" />
      <BatteryFull className="w-5 h-5" />
    </span>
  </div>
);

export default StatusBar;
